import React, { useEffect, useState } from 'react';
import Header from './Header';
import API_URL from '../config';

function RevendaDashboardPage({ usuario, empresa, onVoltar, onSair }) {
  const [total, setTotal] = useState(0);
  const [ativas, setAtivas] = useState(0);
  const [inativas, setInativas] = useState(0);
  const [usuariosTotal, setUsuariosTotal] = useState(0);
  const [usuariosAtivos, setUsuariosAtivos] = useState(0);
  const [usuariosInativos, setUsuariosInativos] = useState(0);
  const [licencasTotal, setLicencasTotal] = useState(0);
  const [licencasAtivas, setLicencasAtivas] = useState(0);
  const [licencasInativas, setLicencasInativas] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchDados() {
      setLoading(true);
      try {
        const res = await fetch(`${API_URL}/pessoas?revenda_id=${empresa.id}`);
        const empresas = await res.json();
        setTotal(empresas.length);
        setAtivas(empresas.filter(e => e.ativo !== false).length);
        setInativas(empresas.filter(e => e.ativo === false).length);
        // Buscar usuários e licenças de todas as empresas
        let usuariosTotal = 0, usuariosAtivos = 0, usuariosInativos = 0;
        let licencasTotal = 0, licencasAtivas = 0, licencasInativas = 0;
        for (const emp of empresas) {
          // Usuários
          try {
            const resU = await fetch(`${API_URL}/empresas_usuarios?empresa_id=${emp.id}`);
            const usuarios = await resU.json();
            usuariosTotal += usuarios.length;
            usuariosAtivos += usuarios.filter(u => u.ativo !== false).length;
            usuariosInativos += usuarios.filter(u => u.ativo === false).length;
          } catch {}
          // Licenças
          try {
            const resL = await fetch(`${API_URL}/dispositivos?empresa_id=${emp.id}`);
            const licencas = await resL.json();
            licencasTotal += licencas.length;
            licencasAtivas += licencas.filter(l => l.ativo !== false).length;
            licencasInativas += licencas.filter(l => l.ativo === false).length;
          } catch {}
        }
        setUsuariosTotal(usuariosTotal);
        setUsuariosAtivos(usuariosAtivos);
        setUsuariosInativos(usuariosInativos);
        setLicencasTotal(licencasTotal);
        setLicencasAtivas(licencasAtivas);
        setLicencasInativas(licencasInativas);
      } catch {
        setTotal(0);
        setAtivas(0);
        setInativas(0);
        setUsuariosTotal(0);
        setUsuariosAtivos(0);
        setUsuariosInativos(0);
        setLicencasTotal(0);
        setLicencasAtivas(0);
        setLicencasInativas(0);
      }
      setLoading(false);
    }
    fetchDados();
  }, [empresa.id]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header usuario={usuario} empresa={empresa} onVoltar={onVoltar} onSair={onSair} />
      <div className="max-w-3xl mx-auto mt-12 p-8 bg-white rounded-2xl shadow-2xl border border-blue-100 flex flex-col items-center">
        <h2 className="text-3xl font-bold text-blue-700 mb-8">Dashboard da Revenda</h2>
        {loading ? (
          <div className="text-blue-600 text-lg">Carregando...</div>
        ) : (
          <>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full mb-8">
              <div className="bg-blue-50 rounded-xl shadow flex flex-col items-center p-8 border-t-4 border-blue-500">
                <svg className="w-10 h-10 mb-2 text-blue-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 21V7a2 2 0 012-2h2a2 2 0 012 2v14M13 21V3a2 2 0 012-2h2a2 2 0 012 2v18M9 21h6" />
                </svg>
                <span className="text-2xl font-bold text-blue-800">{total}</span>
                <span className="text-blue-700 mt-1 font-semibold">Total de Empresas</span>
              </div>
              <div className="bg-green-50 rounded-xl shadow flex flex-col items-center p-8 border-t-4 border-green-500">
                <svg className="w-10 h-10 mb-2 text-green-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 21V7a2 2 0 012-2h2a2 2 0 012 2v14M13 21V3a2 2 0 012-2h2a2 2 0 012 2v18M9 21h6" />
                </svg>
                <span className="text-2xl font-bold text-green-800">{ativas}</span>
                <span className="text-green-700 mt-1 font-semibold">Empresas Ativas</span>
              </div>
              <div className="bg-red-50 rounded-xl shadow flex flex-col items-center p-8 border-t-4 border-red-500">
                <svg className="w-10 h-10 mb-2 text-red-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                <span className="text-2xl font-bold text-red-800">{inativas}</span>
                <span className="text-red-700 mt-1 font-semibold">Empresas Inativas</span>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full mb-8">
              <div className="bg-blue-50 rounded-xl shadow flex flex-col items-center p-8 border-t-4 border-blue-500">
                <svg className="w-10 h-10 mb-2 text-blue-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" /></svg>
                <span className="text-2xl font-bold text-blue-800">{usuariosTotal}</span>
                <span className="text-blue-700 mt-1 font-semibold">Total de Usuários</span>
              </div>
              <div className="bg-green-50 rounded-xl shadow flex flex-col items-center p-8 border-t-4 border-green-500">
                <svg className="w-10 h-10 mb-2 text-green-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" /></svg>
                <span className="text-2xl font-bold text-green-800">{usuariosAtivos}</span>
                <span className="text-green-700 mt-1 font-semibold">Usuários Ativos</span>
              </div>
              <div className="bg-red-50 rounded-xl shadow flex flex-col items-center p-8 border-t-4 border-red-500">
                <svg className="w-10 h-10 mb-2 text-red-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                <span className="text-2xl font-bold text-red-800">{usuariosInativos}</span>
                <span className="text-red-700 mt-1 font-semibold">Usuários Inativos</span>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full">
              <div className="bg-blue-50 rounded-xl shadow flex flex-col items-center p-8 border-t-4 border-blue-500">
                <svg className="w-10 h-10 mb-2 text-blue-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>
                <span className="text-2xl font-bold text-blue-800">{licencasTotal}</span>
                <span className="text-blue-700 mt-1 font-semibold">Total de Licenças</span>
              </div>
              <div className="bg-green-50 rounded-xl shadow flex flex-col items-center p-8 border-t-4 border-green-500">
                <svg className="w-10 h-10 mb-2 text-green-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>
                <span className="text-2xl font-bold text-green-800">{licencasAtivas}</span>
                <span className="text-green-700 mt-1 font-semibold">Licenças Ativas</span>
              </div>
              <div className="bg-red-50 rounded-xl shadow flex flex-col items-center p-8 border-t-4 border-red-500">
                <svg className="w-10 h-10 mb-2 text-red-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                <span className="text-2xl font-bold text-red-800">{licencasInativas}</span>
                <span className="text-red-700 mt-1 font-semibold">Licenças Inativas</span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default RevendaDashboardPage; 